import SocketState from './socketstate'
import { Route } from './route-classes'
interface WSOptions {
    host: string
    port?: number
    wss?: boolean
}


export class Message {
    constructor(private input: object, private path: string) {
    }
    get toString() {
        const path = this.path
        const input = this.input
        return JSON.stringify({ path, input })
    }
}
class WS {
    public connected: boolean = false

    public onOpen: () => void
    public onError: () => void
    public onClose: () => void
    protected Socket: WebSocket
    constructor(private options: WSOptions) {
        const address = `${options.wss ? 'wss' : 'ws'}://${options.host}${options.port ? ':' + options.port : ''}`
        this.Socket = new WebSocket(address)
        this.Socket.addEventListener('open', () => { if (this.onOpen) this.onOpen(); this.connected = true })
        this.Socket.addEventListener('error', () => { if (this.onError) this.onError(); this.Socket.close() })
        this.Socket.addEventListener('close', () => { if (this.onClose) this.onClose(); this.connected = false })
        this.Socket.addEventListener('message', (m) => {
            this.State = m.data
        })
    }
    terminate(){this.Socket.close(); this.Socket = null}
    set State(input: string) {
        let parse: { path: string, input: object }
        try {
            parse = JSON.parse(input)
            if (SocketState.get(parse.path) &&
                parse.input !== undefined) {
                SocketState.set({ [parse.path]: Object.assign(new Route('loaded'), parse.input) })
            }
        } catch (err) {
            console.log(err)
        }
    }
    public Send(path: string, input: object) {
        if (this.Socket && this.Socket.readyState === this.Socket.CONNECTING) return setTimeout(()=>this.Send(path, input),1000)
        if (this.Socket && this.connected && this.Socket.readyState === this.Socket.OPEN) {
            const m = new Message(input, path)
            const o = SocketState.get(path)
            o.loading = 'loading'
            SocketState.set({ [path]: o })
            this.Socket.send(m.toString)
        } else {
            this.connected = false
            const address = `${this.options.wss ? 'wss' : 'ws'}://${this.options.host}${this.options.port ? ':' + this.options.port : ''}`
            this.Socket = new WebSocket(address)
            this.Socket.addEventListener('open', () => {
                if (this.onOpen) this.onOpen()
                this.connected = true
                const m = new Message(input, path)
                const o = SocketState.get(path)
                o.loading = 'loading'
                SocketState.set({ [path]: o })
                
                this.Socket.send(m.toString) })
            this.Socket.addEventListener('error', () => { if (this.onError) this.onError(); this.Socket.close() })
            this.Socket.addEventListener('close', () => { if (this.onClose) this.onClose(); this.connected = false })
            this.Socket.addEventListener('message', (m) => {
                this.State = m.data
            })        
        }
    }
    Get<T>(state: string): T {
        return SocketState.get(state)
    }
    Set<T>(state: string, input: T) {
        delete input['loading']
        SocketState.set({ [state]: Object.assign(input, { loading: 'loaded' }) })
    }
}
export default WS


// WEBPACK FOOTER //
// ./src/Socket/Socket.ts